import fetch from 'isomorphic-fetch'

function callFetchApi (endpoint) {
  return fetch(endpoint)
    .then(res => res.text().then(text => ({ text, res })))
    .then(({ text, res }) => res.ok ? text : Promise.reject(text))
}

export const CALL_API = Symbol('Call API')

export default store => next => action => {
  const callApiConfig = action[CALL_API]
  if (typeof callApiConfig === 'undefined') {
    return next(action)
  }

  const {
    endpoint,
    types
  } = callApiConfig

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.')
  }

  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.')
  }

  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.')
  }

  function actionWith (data) {
    const finalAction = { ...action, ...data }
    delete finalAction[CALL_API]
    return finalAction
  }

  const [
    requestType,
    successType,
    failureType
  ] = types

  next(actionWith({ type: requestType }))

  return callFetchApi(endpoint).then(
    response => next(actionWith({
      response,
      type: successType
    })),
    error => next(actionWith({
      type: failureType,
      error: error.message || 'Error in load activity API'
    }))
  )
}
